import { render, staticRenderFns } from "./LicitacaoFornecedorEsclarecimentoImpugnacao.vue?vue&type=template&id=71be4520&scoped=true"
import script from "./LicitacaoFornecedorEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./LicitacaoFornecedorEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71be4520",
  null
  
)

export default component.exports